import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'
import { InfoWindow } from 'react-google-maps'
import moment from 'moment'
import { toastr } from 'react-redux-toastr'
import momentDurationFormatSetup from 'moment-duration-format'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { IoCloseOutline } from "react-icons/io5";

import { requestEventVideo } from '../../../action/AlertActions';
import { getDurationTimeFormat, getDurationUnitFormat } from '../../../component/helpers/helperTripsGrid'
import momenttz from '../../../component/helpers/momenttz'
import './MarkerInfoPopup.sass'
import CustomButton from "../../../component/CustomButton";

momentDurationFormatSetup(moment);

const TripSpeedEventPopup = (props) => {
	const { user, event, position, toggleLoader, setShowSpeedEventPopup } = props;
	const { t } = useTranslation();

	useEffect(() => {
		setTimeout(() => {
			$('.gm-ui-hover-effect').remove()
		}, 10)
	}, [])

	const createCustomClip = (e) => {
		e.preventDefault();

		const { event, device_id } = props;
		let startTs = momenttz(event.start_ts)
		let endTs = momenttz(event.end_ts);
		const diff = moment(event.end_ts).diff(moment(event.start_ts), 'seconds');
		if (diff < 10) {
			startTs = momenttz(event.start_ts).add(-10, 'seconds');
		} else if (diff > (5 * 60)) {
			endTs = momenttz(event.start_ts).add(5 * 60, 'seconds');
		}

		const params = {
			device_id,
			start_ts: startTs.format('YYYYMMDDHHmmss'),
			end_ts: endTs.format('YYYYMMDDHHmmss'),
		}
		toggleLoader(true);
		requestEventVideo(params)
			.then((res, err) => {
				toggleLoader(false);
				toastr.success('', t('toastMessage.toastrSuccessCVR'));
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('requestCustomVideo error:', error.response, error);
				let errDescription = t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error;
				}
				toastr.error(errDescription);
			});
	}

	const vehicleSpeed = () => {
		let speedRes = +event.speed || 0;
		if (user.speed_unit === 'mph') {
			speedRes /= 1.609344
		}

		return speedRes.toFixed(0);
	}

	const vehicleSpeedLimit = () => {
		if (!event.speed_limit) {
			return 'N/A';
		}

		let speedRes = +event.speed_limit || 0;
		if (user.speed_unit === 'mph') {
			speedRes /= 1.609344;
		}

		return Math.round(speedRes / 5) * 5;
	}

	return (
		<InfoWindow
			zIndex={10000000}
			position={position}
		>
			<div className="markerInfoPopup markerHistoryPopup">
				<CustomButton
					prefix="speed-popup-close-button"
					variant='empty'
					size='icon'
					onClick={() => setShowSpeedEventPopup(false)}
				>
					<IoCloseOutline />
				</CustomButton>
				<div className="headerWrapper">
					<div className="header">
						<Row>
							<Col className="menu" md={12} sm={12} xs={12}>
								<Col
									className="trip-speed-event-popup"
									md={12}
									sm={12}
									xs={12}
									style={{
										display: 'inline-flex',
										alignItems: 'center',
										justifyContent: 'center',
										marginBottom: '10px',
										padding: '5px 8px 0px',
										color: '#fff',
										minWidth: '120px',
									}}
								>
									<div className="drive-info-wrapper">
										<div className="popup-info-row">
											<i className="fa fa-clock"
											   style={{fontSize: '30px', minWidth: '48px', textAlign: 'center'}}
											   title="Event Duration"
											/>
											<span style={{fontSize: '22px', fontWeight: 'bold'}}>
												{getDurationTimeFormat(event.duration)}
												<span style={{fontSize: '14px', textAlign: 'center'}}>
													{getDurationUnitFormat(event.duration).toUpperCase()}
												</span>
											</span>
										</div>
										<div className="popup-info-row">
											<div className="menuItem speed" title="Speed Moving"/>
											<span style={{fontSize: '22px', fontWeight: 'bold'}}>
												{vehicleSpeed()}
												<span style={{fontSize: '14px'}}>
													{user.speed_unit.toUpperCase()}
												</span>
											</span>
										</div>
									</div>
									<div className="popup-info-row">
										<div className="speed-limit-wrapper">
											<div className='speed-limit-label'>
												{t('homePage.tripSpeedEventPopup.textSpeed')}
											</div>
											<div className='speed-limit-label'>
												{t('homePage.tripSpeedEventPopup.textLimit')}
											</div>
											<div className='speed-limit-label speed'>
												{vehicleSpeedLimit()}
											</div>
										</div>
										<label className='speed-unit-label'>
											{user.speed_unit.toUpperCase()}
										</label>
									</div>
								</Col>
							</Col>
						</Row>
						<div className="addressWrapper">
							<div style={{
								minHeight: '60px',
								paddingTop: '14px',
								textAlign: 'center'
							}}>
								<CustomButton
									variant="link"
									prefix="link-button"
									onClick={createCustomClip}
								>
									{t('homePage.tripSpeedEventPopup.requestVideo')}
								</CustomButton>
							</div>
						</div>
					</div>
				</div>
			</div>
		</InfoWindow>
	)
}

TripSpeedEventPopup.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	event: PropTypes.objectOf(PropTypes.any).isRequired,
	device_id: PropTypes.string.isRequired,
	position: PropTypes.objectOf(PropTypes.any).isRequired,
	selectedTrip: PropTypes.objectOf(PropTypes.any)
};

const mapStateToProps = ({ user }) => ({
	user: user.user,
});

const mapDispatchToProps = (dispatch) => {
	return {
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(TripSpeedEventPopup);
